var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.visible
    ? _c("div", { staticClass: "bg-white card mb-2" }, [
        _c(
          "div",
          {
            staticClass: "card-body d-flex justify-content-evenly",
            staticStyle: { gap: "1.25rem" },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", [
              _c("span", {
                staticClass:
                  "pull-right font-size-200 cursor-pointer toast-close",
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.dismiss.apply(null, arguments)
                  },
                },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "font-weight-bold font-size-125 mb-2" }, [
                _vm._v(_vm._s(_vm._f("trans")("Did you know?"))),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "mb-3" }, [_vm._v(_vm._s(_vm.mainText))]),
              _vm._v(" "),
              _c("div", { staticClass: "d-flex align-items-center" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-info font-weight-bold",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        $event.preventDefault()
                        return _vm.retryJobWithOcrEnabled.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "far fa-chevron-right" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("trans")("Try now")) +
                        "\n                "
                    ),
                  ]
                ),
              ]),
            ]),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c(
        "div",
        {
          staticClass:
            "bg-info text-white d-inline-flex align-items-center justify-content-center toast-icon",
        },
        [_c("i", { staticClass: "far fa-search" })]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }